import { BASE_URL } from "../../../Constant";

export const API_SAVE_REVIEW : string = BASE_URL + '/api/review';
export const API_REVIEW_LOAD_BY_ID: string = BASE_URL + '/api/review'
export const API_REVIEWS_LOAD_BY_BUSINESS_ID: string = BASE_URL + '/api/review/businessId'
